export default __webpack_public_path__ + "static/media/empty-image.09a55e75.svg";